import FormRow from 'components/FormRow';
import Section from '../components/Section';
import Input from 'components/ui/Input';
import useUser from 'hooks/useUser';

const EmailSection = () => {
  const user = useUser();

  return (
    <Section maxWidth={400}>
      <FormRow label="이메일">
        <Input value={user.data?.userEmail} disabled />
      </FormRow>
    </Section>
  );
};

export default EmailSection;
